import React from 'react';
import styled from 'styled-components';
import { H2 } from '../../../Atoms/Typo';

const Component = styled.div`
  ${H2}
`;

interface TitleProps {
  title: string;
}

const Title = ({ title }: TitleProps) => {
  return <Component className="voda_report_title">{title}</Component>;
};

export default Title;
